import React from 'react'
import { Box, Stack } from '@ui'
import { shimmerClass } from 'ui/styles/globals/shimmer.css'

export const TokenListSkeleton = () => (
    <Stack gap="sm" color="gray2" width="100%">
        {Array.from({ length: 6 })
            .map((_, index) => `key_${index}`)
            .map((key, i, l) => (
                <Stack
                    horizontal
                    gap
                    key={key}
                    width="100%"
                    paddingX="sm"
                    height="x6"
                    alignItems="center"
                    style={{
                        opacity: (1 - i / l.length) * 1,
                    }}
                >
                    <Box
                        key={key}
                        background="level3"
                        rounded="sm"
                        height="x5"
                        width="x5"
                        className={shimmerClass}
                    />
                    <Box grow rounded="sm" height="x5" className={shimmerClass} />
                </Stack>
            ))}
    </Stack>
)
